<script setup>
import { getI18n } from '@/plugins/i18n'

import InfoBox from '@/components/shared/InfoBox.vue'
import DocumentLanguageSelect from '@/components/shared/DocumentLanguageSelect.vue'
import PrintOptionToggles from '@/components/shared/PrintOptionToggles.vue'
import PrintTemplateStrip from '@/components/accounting/PrintTemplateStrip.vue'

defineProps({
  documentType: {
    type: Number,
    required: true,
  },
  printTemplate: {
    type: Number,
    required: false,
    default: null,
  },
  language: {
    type: String,
    required: false,
    default: null,
  },
  lockedTemplateMessage: {
    type: String,
    required: false,
    default: null,
  },
  options: {
    type: Array,
    required: false,
    default: () => [],
  },
})

const emit = defineEmits(['update:printTemplate', 'update:language', 'update:option'])

const i18n = getI18n()
</script>
<template>
  <div class="column q-gutter-y-md">
    <div>
      <div class="text-caption text-grey-7 q-mb-xs">{{ i18n.t('common.printTemplate') }}</div>
      <print-template-strip
        :model-value="printTemplate"
        :document-type="documentType"
        :disable="!!lockedTemplateMessage"
        @update:model-value="value => emit('update:printTemplate', value)"
      />
      <info-box v-if="lockedTemplateMessage" :message="lockedTemplateMessage" />
    </div>
    <document-language-select :model-value="language" @update:model-value="value => emit('update:language', value)" />
    <slot />
    <print-option-toggles v-if="options.length" :options="options" @update="(key, value) => emit('update:option', key, value)" />
  </div>
</template>
